"use client"

import { BadgeIndianRupee } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BadgeIndianRupeeIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BadgeIndianRupeeIcon = component(Icon)({ as: BadgeIndianRupee })
